import { GridColDef } from "@mui/x-data-grid-pro";

/**
 * GenerateTreinamentoCargoColumnDefs
 */

export const GenerateTreinamentoCargoColumnDefs = (): GridColDef[] => {
  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Cargo",
      flex: 1,
      sortable: false,
    },
  ];
}